import { AppThunk } from 'clients/app/src/store';

import * as reportsApi from '../../../api/reports/reportsApi';
import { requestFinished, requestSent } from '../teacher/teacherSlice';
import {
  populateStudentRoster,
  untoggleAllStudents,
} from './emailReportsSlice';

interface EmailStudentsPayload {
  activity_instance_id: number | string;
  student_ids: Array<string>;
}

const fetchStudentRoster =
  (activityInstanceId: number): AppThunk =>
  async (dispatch) => {
    dispatch(requestSent());

    const studentRoster = await reportsApi.fetchStudentRoster(
      activityInstanceId
    );
    dispatch(populateStudentRoster({ studentRoster: studentRoster }));
    dispatch(untoggleAllStudents());
    dispatch(requestFinished());
  };

const emailReportsToStudents =
  (payload: EmailStudentsPayload): AppThunk =>
  async (dispatch) => {
    dispatch(requestSent());
    await reportsApi.emailReportsToStudents(payload);
    dispatch(requestFinished());
  };

export { fetchStudentRoster, emailReportsToStudents };
